import {
  normalizeMarketingTouch,
  type MarketingTouch,
} from "../../shared/marketingAttribution";

const FIRST = "bliss_marketing_first_touch";
const LAST = "bliss_marketing_last_touch";
let first: MarketingTouch | null = null;
let last: MarketingTouch | null = null;
let observedUrl = "";

/** Capture before client-side navigation removes the campaign query string. */
export function rememberMarketingTouch(): void {
  if (typeof window === "undefined") return;
  try {
    first ||= JSON.parse(sessionStorage.getItem(FIRST) || "null");
    last ||= JSON.parse(sessionStorage.getItem(LAST) || "null");
  } catch {
    /* Storage is optional; retain this page's in-memory attribution. */
  }
  if (observedUrl === window.location.href) return;
  observedUrl = window.location.href;
  const query = new URLSearchParams(window.location.search);
  let referrerHost = "";
  try {
    referrerHost = document.referrer ? new URL(document.referrer).hostname : "";
  } catch {
    /* Invalid referrer. */
  }
  if (/(^|\.)blissbunkbeds\.com$/i.test(referrerHost)) referrerHost = "";
  const explicitCampaign = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_id",
    "campaign_id",
    "ad_group_id",
    "utm_content",
    "creative_id",
    "ad_id",
  ].some((key) => query.has(key));
  // A document referrer repeats on SPA navigation; it is not a new marketing touch.
  if (last && !explicitCampaign) return;
  const touch = normalizeMarketingTouch({
    source:
      query.get("utm_source") ||
      (explicitCampaign ? "campaign" : referrerHost ? "" : "direct"),
    medium: query.get("utm_medium"),
    campaign: query.get("utm_campaign"),
    campaignId: query.get("campaign_id") || query.get("utm_id"),
    creativeId: query.get("creative_id"),
    adId: query.get("ad_id"),
    content: query.get("utm_content"),
    term: query.get("utm_term"),
    referrerHost,
    landingPath: window.location.pathname,
  });
  if (!touch) return;
  first ||= touch;
  last = touch;
  try {
    sessionStorage.setItem(FIRST, JSON.stringify(first));
    sessionStorage.setItem(LAST, JSON.stringify(last));
  } catch {
    /* Attribution must never prevent lead capture. */
  }
}

export function readMarketingAttribution() {
  rememberMarketingTouch();
  return { firstTouch: first, lastTouch: last };
}

export function resetMarketingAttributionForTests() {
  first = null;
  last = null;
  observedUrl = "";
}

